export function resizedPath(
  path: string,
  width: number | null = null,
  height: number | null = null
): string {
  const pathWithoutEnding = path.replace(/\.\w+$/, "");
  const ending = path.replace(/.*(\.\w+)$/, "$1");
  const w = width ? `-w${width}` : "";
  const h = height ? `-h${height}` : "";
  return `${pathWithoutEnding}${w}${h}${ending}`;
}
